// extracted by mini-css-extract-plugin
export default {"formListWrapper":"Refund_formListWrapper__dtb5R","delete":"Refund_delete__uoIC8","totalAmount":"Refund_totalAmount__j2mWQ"};